import React from "react";
import { 
        Container, 
        Grid,
        Link
    } from "@mui/material";

const DesktopMenu = (props) => {
    const menulist = props.menuList.map(function(value, i){
        if( i == 3){
            return (
                <Link href="/" className="Globle---Meta--logo-Shadow position-relative py-2">
                    {/* <span className="blue">
                        Meta
                    </span>
                    &nbsp;
                    <span className="pink">
                         snooker
                    </span> */}
                    <img src={props.siteLogo} className="img-fluid w-100" />
                </Link>
            );
        }else{
            return (
                <Link href={value[1]} className={value[2]}>
                    {value[0]}
                </Link>
            );
        }
    });
    return (
        <Container maxWidth="xl">
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                className="Global---NavMenu" 
            >
                <Grid
                    xs={12}
                    className="text-center"
                >
                    {menulist}
                </Grid>
            </Grid>
        </Container>
    );
}

export default DesktopMenu;
